export default __webpack_public_path__ + "static/media/thumbs-up.4c32de25.svg";